import { Vue, newVue } from '@/config/vue'

On.VueInit({
  controller: 'sustainability',
  init() {
    const Sustainability = Vue.component('sustainability', () =>
      import(/* webpackChunkName: "sustainability" */ './Sustainability.vue')
    )
    newVue({
      render: h => h(Sustainability),
      mount: '.sustainability',
    })
  },
})
